<template>
  <div class="report-footer">
    <DivPrintableBackground ref="bg">
      <h3>Looking for more?</h3>
      <ul>
        <template v-if="!isSelectedSchoolPK">

          <li>Find the full set of survey questions and responses in the <LinkExternalUrl :url="guideURL">School Quality Guide</LinkExternalUrl>. Also check the Guide for more about school demographics<template v-if="['EC','D75'].indexOf(selectedSchoolType)==-1"> and student achievement</template>.</li>

          <template v-if="selectedSchoolType!=='YABC'">
            <li v-if="isSelectedSchoolCharter">Charter schools do not receive Quality Reviews.</li>
            <li v-else-if="!hasQRReview">For more information about the Quality Review process, visit the <LinkExternalUrl url="https://www.schools.nyc.gov/about-us/reports/school-quality/quality-review">Quality Review page of the DOE website</LinkExternalUrl>.</li>
            <li v-else>Read the complete <LinkExternalUrl :url="qualityReviewURL">Quality Review Report (PDF)</LinkExternalUrl>.</li>
          </template>

          <li v-if="selectedSchoolType==='HS'">The <LinkExternalUrl :url="schoolFinderURL">NYC School Finder</LinkExternalUrl> provides admissions information.</li>
          <li v-else-if="selectedSchoolType==='MS'"><LinkExternalUrl url="https://schools.nyc.gov/enrollment/enroll-grade-by-grade/middle-school">Middle School Directories</LinkExternalUrl> provide admissions information.</li>
          <li v-else-if="['EC','ES','K-8'].indexOf(selectedSchoolType)>-1"><LinkExternalUrl url="https://schools.nyc.gov/enrollment/enroll-grade-by-grade/kindergarten">Kindergarten Directories</LinkExternalUrl> provide admissions information.</li>
          <li v-else-if="['YABC','HST'].indexOf(selectedSchoolType)>-1">Find <LinkExternalUrl url="https://schools.nyc.gov/enrollment/other-ways-to-graduate/learn-about-other-ways-to-graduate">admissions resources for alternative schools</LinkExternalUrl>.</li>
          <!-- No link for D75 -->

          <li>Multi-year performance data is available on the <LinkExternalUrl :url="dashboardURL">School Performance Dashboard</LinkExternalUrl>.</li>
        </template>
        <template v-else>
          <li>Find Pre-K sites with the <LinkExternalUrl url="https://maps.nyc.gov/prek">Pre-K Finder</LinkExternalUrl> online map.</li>
          <li><LinkExternalUrl url="https://www.schools.nyc.gov/enrollment/enroll-grade-by-grade/pre-k">Pre-K Directories</LinkExternalUrl> provide admissions information.</li>
          <li>Find out more about the <LinkExternalUrl url="http://NYCSchoolSurvey.org">NYC School Survey</LinkExternalUrl>.</li>
        </template>
      </ul>
    </DivPrintableBackground>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Component from 'vue-class-component'

import { NS_REPORT_GROUP, NS_CURRENT_REPORT } from './const'
import { qrURL } from '@/utils/data'

import DivPrintableBackground from '@/components/DivPrintableBackground'
import LinkExternalUrl from '@/components/LinkExternalUrl'

@Component({
  computed: {
    ...mapGetters(NS_REPORT_GROUP, [
      'reportYear'
    ]),
    ...mapGetters(NS_CURRENT_REPORT, [
      'selectedSchool',
      'selectedSchoolType',
      'isSelectedSchoolCharter',
      'isSelectedSchoolPK',
      'isSelectedSchoolDistrictPK',
      'selectedSchoolQRYear',
      'hasQRReview'
    ])
  },
  components: {
    DivPrintableBackground,
    LinkExternalUrl
  }
})
export default class ReportFooter extends Vue {
  /* Lifecycle */
  updated () {
    this.updateBGSize()
  }

  /* Getters */

  get schoolFinderURL () {
    return this.selectedSchool && this.selectedSchool.dbn
      ? `http://schoolfinder.nyc.gov/#/schools/${this.selectedSchool.dbn}` : 'http://schoolfinder.nyc.gov'
  }
  get qualityReviewURL () {
    return qrURL(this.selectedSchool, this.selectedSchoolQRYear)
  }
  get guideURL () {
    let url = `/guide/${this.reportYear}/`
    if (this.selectedSchool && this.selectedSchool.dbn) {
      url += `#dbn=${this.selectedSchool.dbn}`
      if (this.selectedSchool.report_type && !this.isSelectedSchoolDistrictPK) {
        url += `&report_type=${this.selectedSchool.report_type}`
      }
    }
    return url
  }
  get dashboardURL () {
    return this.selectedSchool && this.selectedSchool.dbn && this.selectedSchool.report_type
      ? `/dashboard/#dbn=${this.selectedSchool.dbn}&report_type=${this.selectedSchool.report_type}` : `/dashboard/`
  }

  /* Methods - utility */

  updateBGSize () {
    // When content repopulates for print URLs, need to update background size
    //  However, this does not update calculation based on CSS content: rules
    const bg = this.$refs.bg
    if (bg) {
      bg.$_RootSizeMixin_updateInnerSize()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './css/const.scss';
$bg-color: #b7d1ed;

.div-printable-bg {
  background-color: $bg-color;
  border-color: $bg-color;
  padding: 0px;
  /deep/ .content {
    padding: 24px;
    > * {
      display: block;
    }
  }
}
ul {
  margin-bottom: 0px;
  padding-left: 24px;
}
.report-footer h3 {
  color: black;
  border-bottom: 0px;
  margin: 0px;
}

/* Responsive rules */

@media screen and (max-width: $screen-width-2-column-small) {
.div-printable-bg /deep/ .v-outer {
  margin: 0px 10px;
  width: calc(100% - 20px);
  .content {
    padding-left: 0px;
    padding-right: 0px;
  }
}
}
@media screen and (max-width: $screen-width-1-column-large) {
.div-printable-bg /deep/ .v-outer {
  max-width: $max-width-1-col;
  margin: auto;
}
}
@media screen and (max-width: $screen-width-1-column-medium) {
.div-printable-bg /deep/ .v-outer {
  max-width: none;
  margin: 0px;
  .content {
    padding-left: 10px;
    padding-right: 10px;
  }
}
}

</style>



// WEBPACK FOOTER //
// src/components/sqs/2017/ReportFooter.vue